module.exports = __webpack_public_path__ + "img/man.2fbdbb99.png";